import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, createBlueprintSuccess, createBlueprintFailure } from '../../actions/blueprints/create';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  try {
    const headers = getLocalUser();
    
    // Add workspace ID to headers if available in the payload
    if (action.payload.workspace_id) {
      headers['X-WORKSPACE-ID'] = action.payload.workspace_id;
    }
    
    // Create a clean payload without the workspace_id field
    const { workspace_id, ...cleanPayload } = action.payload;

    const response = yield call(axios.post, 
      `${config.API_URL}/models`,
      cleanPayload,
      { headers }
    );

    yield put(createBlueprintSuccess(response.data.data));
  } catch (error) {
    console.error('Blueprint create error:', error);
    console.error('Error response data:', error?.response?.data);
    console.error('Error status:', error?.response?.status);
    yield put(Error(error));
    yield put(createBlueprintFailure(extractErrorMessage(error)));
  }
}

export default function* watchCreateBlueprint() {
  yield takeLatest(REQUEST, operation);
} 